import { Link } from "react-router-dom";
import { MapPin, Phone, Mail } from "lucide-react";
import { useI18n } from "@/context/I18nContext";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_pure-milk-navi/artifacts/sptl1rmt_image%201.png";

export default function Footer() {
  const { t } = useI18n();
  const a = t.footer.areas;
  return (
    <footer className="bg-dd-green-deep text-white relative overflow-hidden" data-testid="site-footer">
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-dd-gold to-transparent" />
      <div className="dd-container py-14 md:py-20">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <div className="flex items-center gap-3">
              <img src={LOGO_URL} alt="Divya Dhara" className="w-14 h-14 rounded-full bg-white/95 p-1" />
              <div>
                <div className="font-serif italic text-2xl text-dd-gold-soft">Divya Dhara</div>
                <div className="dd-label text-[0.6rem] text-dd-gold">Har Boond Mein Amrit</div>
              </div>
            </div>
            <p className="mt-5 text-sm text-white/70 leading-relaxed">
              {t.footer.tagline}
            </p>
          </div>

          <div>
            <div className="dd-label text-dd-gold-soft mb-4">{t.footer.quick_links}</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="text-white/80 hover:text-dd-gold-soft">{t.footer.home}</Link></li>
              <li><Link to="/#founders" className="text-white/80 hover:text-dd-gold-soft">{t.footer.founders}</Link></li>
              <li><Link to="/gallery" className="text-white/80 hover:text-dd-gold-soft">{t.footer.gallery}</Link></li>
              <li><Link to="/#delivery" className="text-white/80 hover:text-dd-gold-soft">{t.footer.delivery}</Link></li>
              <li><a href="tel:+919819933676" className="text-white/80 hover:text-dd-gold-soft">Corporate Plans</a></li>
            </ul>
          </div>

          <div>
            <div className="dd-label text-dd-gold-soft mb-4">{t.footer.delivery_areas}</div>
            <ul className="space-y-1.5 text-sm text-white/70 grid grid-cols-2 gap-x-4">
              <li>{a.vashi}</li>
              <li>{a.sanpada}</li>
              <li>{a.turbhe}</li>
              <li>{a.juinagar}</li>
              <li>{a.nerul}</li>
              <li>{a.seawoods}</li>
              <li>{a.belapur}</li>
              <li>{a.ghansoli}</li>
              <li>{a.kopar}</li>
              <li>{a.rabale}</li>
              <li>{a.airoli}</li>
            </ul>
            <div className="dd-label text-dd-gold-soft/70 text-[0.58rem] mt-4 mb-2">Coming Soon</div>
            <ul className="text-xs text-white/50 grid grid-cols-2 gap-x-4 gap-y-1">
              <li>{a.kharghar}</li>
              <li>{a.kamothe}</li>
              <li>{a.kalamboli}</li>
              <li>{a.taloja}</li>
              <li>{a.panvel}</li>
            </ul>
          </div>

          <div>
            <div className="dd-label text-dd-gold-soft mb-4">{t.footer.reach_us}</div>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2 text-white/80">
                <MapPin className="w-4 h-4 mt-0.5 text-dd-gold-soft" strokeWidth={1.5} />
                <span>{t.contact.address}</span>
              </li>
              <li className="flex items-center gap-2 text-white/80">
                <Phone className="w-4 h-4 text-dd-gold-soft" strokeWidth={1.5} />
                <a href="tel:+919819933676" className="hover:text-dd-gold-soft">+91 98199 33676</a>
              </li>
              <li className="flex items-center gap-2 text-white/80">
                <Mail className="w-4 h-4 text-dd-gold-soft" strokeWidth={1.5} />
                <a href="mailto:matrubhumigaurasbhandar@gmail.com" className="hover:text-dd-gold-soft">matrubhumigaurasbhandar@gmail.com</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col md:flex-row gap-3 justify-between text-xs text-white/60">
          <div>© {new Date().getFullYear()} Divya Dhara Milk · Matrubhumi Gauras Bhandar. {t.footer.rights}</div>
          <div>Founded by Rajesh Jain &amp; Darshan Bhardwaj · {t.footer.fssai}</div>
        </div>
      </div>
    </footer>
  );
}
